import { render, staticRenderFns } from "./coderProDxsPivoted.vue?vue&type=template&id=5586061b&scoped=true&"
import script from "./coderProDxsPivoted.vue?vue&type=script&lang=js&"
export * from "./coderProDxsPivoted.vue?vue&type=script&lang=js&"
import style0 from "./coderProDxsPivoted.vue?vue&type=style&index=0&id=5586061b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5586061b",
  null
  
)

export default component.exports